export const PLACEHOLDER_PATTERN = "{{placeholder}}";
